import MessageComponent from "./components/message-center/index";
import MessageStore from "./stores/index";
import FixedPop from "./components/fixedPop";
import DialogComponent from "./components/dialogMode/index";
import SingleMessage from "./components/message-center/singleMessage";
import middleware from "../../middleware";

// 高阶函数，用来统一处理异步 config.js
import AsyncHoc from "./components/async-hoc";

let messageComponent = AsyncHoc(MessageComponent, "MessageComponent");
let fixedPop = AsyncHoc(FixedPop, "FixedPop");
let dialogComponent = AsyncHoc(DialogComponent, "DialogComponent");
export default {
  Component: middleware(messageComponent, "WeaMessageCenter"),
  DialogComponent: middleware(dialogComponent, "WeaDialogComponent"),
  Store: MessageStore,
  FixedPop: middleware(fixedPop, "WeaFixedPop"),
  SingleMessage: middleware(SingleMessage, "WeaSingleMessage")
};



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/index.js